import React, { useState, useEffect, useContext } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import avatar from "../../Assets/Images/avatar.png";
import { useKeycloak } from "@react-keycloak/web";
import { LayoutState } from "../../Context/LayoutContext/LayoutContext";
import { useSelector } from "react-redux";
import { RoleContext } from "../..";

import IResponse_Logo from "../../Assets/Icons/IResponse_Logo.svg";
import { Button, Modal } from "react-bootstrap";
import { BellIcon, AlertTriangle, Flame, Droplets, AlertCircle, Siren } from "lucide-react";

import { getData, putDataWithBody, postDataWithBody } from "../../Services/Services";
import { alertsgetall, getThemeURL, markallalert, singlealert, getNotificationsList, notificationRead, notificationMarkAllRead } from "../../Services/EndPoints";
import { toast } from "react-toastify";
import { t } from "i18next";
import ToastNotification from "./ToastNotification";



const Header = ({ children }) => {
  const { collapsed } = LayoutState();
  const [avtarImg, setAvtarImg] = useState(avatar);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { profileData } = useSelector((store) => store.data);
  const { roleName } = useContext(RoleContext);

  console.log("rolenamee", roleName)
  // State for notification modal
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [profileRoleName, setProfileRoleName] = useState(null);
  // SOP & Grievance notifications
  const [showSopModal, setShowSopModal] = useState(false);
  const [sopNotifications, setSopNotifications] = useState([]);
  const [sopNotificationCount, setSopNotificationCount] = useState(0);
  const [sopActiveTab, setSopActiveTab] = useState("grievance");

  const fetchSopNotifications = async () => {
    try {
      const response = await getData(getNotificationsList);
      const data = response?.data || [];
      setSopNotifications(data);
      setSopNotificationCount(data.filter(n => !n.isRead).length);
    } catch (err) {
      console.error("Error fetching SOP/Grievance notifications:", err);
    }
  };

  const markSopNotificationRead = async (id) => {
    try {
      // Single read: GET /grievance-notifications/markRead/{id}
      await getData(notificationRead.replace("ID", id));
      await fetchSopNotifications();
    } catch (err) {
      console.error("Error marking SOP notification as read:", err);
    }
  };

  const markAllSopNotificationsRead = async () => {
    try {
      const unreadIds = sopNotifications.filter(n => !n.isRead).map(n => n.id);
      if (unreadIds.length === 0) return;
      // Multiple read: POST /grievance-notifications/markRead with [id1, id2, ...]
      await postDataWithBody(notificationMarkAllRead, { notificationIds: unreadIds }, {});
      await fetchSopNotifications();
    } catch (err) {
      console.error("Error marking all SOP notifications as read:", err);
    }
  };
 

  const handleSopNotificationClick = (notification) => {
    setShowSopModal(false);

    // Mark as read in background — do NOT await so navigation is never blocked
    if (!notification.isRead) {
      markSopNotificationRead(notification.id).catch(err =>
        console.error("Error marking notification as read:", err)
      );
    }

    const { notificationType, grievanceId } = notification;

    if (notificationType === "SOP_EXECUTION") {
      navigate("/Disaster-acknowledgereport/view-sop/Sop-instance-list");
    } else if (notificationType === "RESOURCE_DEPOLY") {
      navigate("/Disaster-acknowledgereport/resource-assign-list");
    } else if (
      notificationType === "TICKET_ESCALATED" ||
      notificationType === "TICKET_RESOLVED" ||
      notificationType === "TICKET_IN_PROGRESS" ||
      notificationType === "TICKET_CREATED" ||
      notificationType === "COMMENT_ADDED"
    ) {
      navigate("/grievance/view-raise-ticket", {
        state: { grievanceSeqId: grievanceId },
      });
    }
  };

  
  useEffect(() => {
    fetchSopNotifications();
    const interval = setInterval(fetchSopNotifications, 30000);
    return () => clearInterval(interval);
  }, []);
  //const [rolename, setrolename] = useState('')
  // Fetch notifications from API
  const fetchNotifications = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData(alertsgetall);
      const fetchedNotifications = response;

      // Map API response to component format
      const mappedNotifications = fetchedNotifications.map(notification => ({
        id: notification.id,
        caseId: `${notification.alertSeqId}`,
        notificationTitle: `${getSeverityEmoji(notification.severity)} ${notification.hazardType}`,
        notificationMessage: notification.notificationMessage,
        createdAt: parseTimestamp(notification.notificationTimestamp),
        isRead: notification.isMarkedAsRead,
        priority: mapSeverityToPriority(notification.severity),
        disasterType: notification.hazardType,
        location: notification.regionName,
        measuredValue: notification.measuredValue,
        thresholdValue: notification.thresholdValue,
        unit: notification.unit,
        alertDescription: notification.alertDescription,
        icon: getDisasterIcon(notification.hazardType),
        // Additional fields for DisasterViewer
        severity: notification.severity,
        latitude: notification.latitude || 34.1526,
        longitude: notification.longitude || 77.5771,
        affectedArea: notification.affectedArea || "N/A",
        affectedPopulation: notification.affectedPopulation || "N/A",
        reportedBy: notification.reportedBy || "Disaster Management System",
        contact: notification.emergencyContact || "+91 1982-XXXXX",
        assessments: notification.assessments || [],
      }));

      setNotifications(mappedNotifications);

      // Update notification count (unread notifications)
      const unreadCount = mappedNotifications.filter(n => !n.isRead).length;
      setNotificationCount(unreadCount);

    } catch (err) {
      console.error("Error fetching notifications:", err);
      setError("Failed to load notifications. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Parse timestamp array to Date object
  const parseTimestamp = (timestamp) => {
    if (!timestamp) return new Date();

    // Handle ISO string e.g. "2026-03-23T14:47:48.004615"
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      return isNaN(date.getTime()) ? new Date() : date;
    }

    // Handle array format e.g. [2026, 3, 23, 14, 47, 48, 576000000]
    if (Array.isArray(timestamp) && timestamp.length >= 6) {
      const [year, month, day, hour, minute, second, nano = 0] = timestamp;
      return new Date(year, month - 1, day, hour, minute, second, Math.floor(nano / 1000000));
    }

    return new Date();
  };

  // Map severity to priority
  const mapSeverityToPriority = (severity) => {
    const severityMap = {
      "Critical": "CRITICAL",
      "Warning": "Warning",
      "Medium": "MEDIUM",
      "Low": "LOW"
    };
    return severityMap[severity] || "MEDIUM";
  };

  // Get emoji based on severity
  const getSeverityEmoji = (severity) => {
    const emojiMap = {
      "Critical": "🚨",
      "Warning": "⚠️",
      "Medium": "⚡",
      "Low": "ℹ️"
    };
    return emojiMap[severity] || "📢";
  };

  // Get icon based on disaster type
  const getDisasterIcon = (hazardType) => {
    const iconMap = {
      "Flood": <Droplets color="#2563eb" size={16} />,
      "Fire": <Flame color="#dc2626" size={16} />,
      "Cyclone": <AlertTriangle color="#ca8a04" size={16} />,
      "Earthquake": <AlertCircle color="#9333ea" size={16} />,
      "Cold Wave": <Droplets color="#3b82f6" size={16} />,
      "Heat Wave": <Flame color="#f59e0b" size={16} />
    };
    return iconMap[hazardType] || <AlertCircle color="#ca8a04" size={16} />;
  };

  // Mark single notification as read
  const markNotificationAsRead = async (notificationId) => {
    try {  //axios.put(`${API_BASE_URL}/${notificationId}/mark-read`);
      const response = await putDataWithBody(singlealert.replace('id', notificationId), '', {})

      if (response.status === "success") {
        // Update local state
        const updatedNotifications = notifications.map(notification => {
          if (notification.id === notificationId) {
            return { ...notification, isRead: true };
          }
          return notification;
        });

        setNotifications(updatedNotifications);

        // Update notification count
        const unreadCount = updatedNotifications.filter(n => !n.isRead).length;
        setNotificationCount(unreadCount);

        // toast.success(
        //   response.msg,
        //   {
        //     position: toast.POSITION.TOP_CENTER,
        //     autoClose: 2000,
        //   }
        // );
      }
    } catch (err) {
      console.error("Error marking notification as read:", err);
      toast.error(
        t('Failed to mark notification as read. Please try again.'),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        }
      );
      //alert("Failed to mark notification as read. Please try again.");
    }
  };

  // Mark all notifications as read
  const handleMarkAllAsRead = async () => {
    try {
      const response = await putDataWithBody(markallalert, '', {});

      if (response.status === "success") {
        // Update all notifications to read
        const updatedNotifications = notifications.map(notification => ({
          ...notification,
          isRead: true
        }));

        setNotifications(updatedNotifications);
        setNotificationCount(0);

        toast.success(
          response.msg,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          }
        );
        // alert(response.msg);
      }
    } catch (err) {
      console.error("Error marking all as read:", err);
      toast.error(
        t("Failed to mark all notifications as read. Please try again."),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        }
      );
      //alert("Failed to mark all notifications as read. Please try again.");
    }
  };

  // Fetch notifications on component mount
  useEffect(() => {
    fetchNotifications();

    // Optional: Set up polling to refresh notifications every 30 seconds
    const interval = setInterval(() => {
      fetchNotifications();
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(() => {
  //   let interval;

  //   if (showNotificationModal) {
  //     // Fetch immediately when modal opens
  //     fetchNotifications();

  //     // Poll every 5 seconds ONLY while modal is open
  //     interval = setInterval(() => {
  //       fetchNotifications();
  //     }, 5000);
  //   }

  //   return () => {
  //     if (interval) clearInterval(interval);
  //   };
  // }, [showNotificationModal]);


  // Use Redux profileData (loaded at app boot) to set userId immediately
  useEffect(() => {
    const profileObj = Array.isArray(profileData) ? profileData[0] : profileData;
    if (profileObj?.id) {
      setCurrentUserId(profileObj.id);
      setProfileRoleName(profileObj.role_name || null);
    }
    setAvtarImg(profileObj?.user_image ? `data:image/jpeg;base64,${profileObj.user_image}` : avatar);
  }, [profileData]);

  useEffect(() => {
    if (keycloak && keycloak.tokenParsed) {
      setAvtarImg(avatar);
      getUserProfile();
    }
  }, [keycloak]);

  const getUserProfile = async () => {
    try {
      const profile = await getData(getThemeURL);
      console.log("response", profile)
      const profileObj = Array.isArray(profile) ? profile[0] : profile;
      if (profileObj && profileObj.id) {
        setCurrentUserId(profileObj.id);
        setProfileRoleName(profileObj.role_name || null);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      //setUserProfile(null);
    }
  };

  const handleShowNotificationModal = () => {
    setShowNotificationModal(true);
  };

  const handleCloseNotificationModal = () => {
    setShowNotificationModal(false);
  };

  // UPDATED: Navigate to DisasterViewer with notification data
  const handleNotificationClick = async (notification) => {
    console.log("Disaster case clicked:", notification);
    setShowNotificationModal(false);
    const serializableNotification = {
      id: notification.id,
      caseId: notification.caseId,
      notificationTitle: notification.notificationTitle,
      notificationMessage: notification.notificationMessage,
      createdAt: notification.createdAt,
      isRead: notification.isRead,
      priority: notification.priority,
      acknowledged: notification.acknowledged || false,
      acknowledgedBy: notification.acknowledgedBy,
      disasterType: notification.disasterType,
      location: notification.location,
      measuredValue: notification.measuredValue,
      actionTaken: notification.actionTaken,
      thresholdValue: notification.thresholdValue,
      unit: notification.unit,
      sensorNetwork: notification.sensorNetwork,
      alertDescription: notification.alertDescription,
      // icon: notification.icon, // REMOVE THIS - it's a React element
      severity: notification.severity,
      latitude: notification.latitude,
      longitude: notification.longitude,
      affectedArea: notification.affectedArea,
      affectedPopulation: notification.affectedPopulation,
      reportedBy: notification.reportedBy,
      contact: notification.contact,
      assessments: notification.assessments || [],
    };

    // Create serializable notifications array
    const serializableNotifications = notifications.map(n => ({
      id: n.id,
      caseId: n.caseId,
      notificationTitle: n.notificationTitle,
      notificationMessage: n.notificationMessage,
      createdAt: n.createdAt,
      isRead: n.isRead,
      priority: n.priority,
      acknowledged: n.acknowledged || false,
      acknowledgedBy: n.acknowledgedBy,
      disasterType: n.disasterType,
      location: n.location,
      sensorNetwork: n.sensorNetwork,

      measuredValue: n.measuredValue,
      thresholdValue: n.thresholdValue,
      unit: n.unit,
      actionTaken: n.actionTaken,
      alertDescription: n.alertDescription,
      // icon: n.icon, // REMOVE THIS
      severity: n.severity,
      latitude: n.latitude,
      longitude: n.longitude,
      affectedArea: n.affectedArea,
      affectedPopulation: n.affectedPopulation,
      reportedBy: n.reportedBy,
      contact: n.contact,
      assessments: n.assessments || [],
    }));

    // Navigate with serializable data only
    navigate('/Disaster-Acknowladgement', {
      state: {
        notificationData: serializableNotification,
        allNotifications: serializableNotifications
      }
    });



    // Mark as read when clicked
    if (!notification.isRead) {
      await markNotificationAsRead(notification.id);
    }


  };
  const handleNotificationReceived = () => {
    // Refresh notification count when new notification arrives
    fetchNotifications();
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "CRITICAL": return "#dc2626";
      case "HIGH": return "#ea580c";
      case "Warning": return "#f59e0b";
      case "LOW": return "#16a34a";
      default: return "#6b7280";
    }
  };

  const getPriorityBgColor = (priority) => {
    switch (priority) {
      case "CRITICAL": return "#fef2f2";
      case "HIGH": return "#fff7ed";
      case "MEDIUM": return "#fefce8";
      case "LOW": return "#f0fdf4";
      default: return "#f9fafb";
    }
  };

  // Rewrites any 24-hour clock time in free text (e.g. "..._25-09-2026 17:19") as 12-hour ("05:19 PM").
  // Times already followed by AM/PM are left alone.
  const to12HourText = (text) =>
    typeof text !== "string"
      ? text
      : text.replace(/\b([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?\b(?!\s*[AaPp][Mm])/g, (_, h, m) => {
          const hour = Number(h);
          const suffix = hour >= 12 ? "PM" : "AM";
          return `${String(hour % 12 || 12).padStart(2, "0")}:${m} ${suffix}`;
        });

  const formatDate = (dateValue) => {
    if (!dateValue) return "NA";

    let date;

    // Handle array format [year, month, day, hour, minute, second]
    if (Array.isArray(dateValue) && dateValue.length >= 5) {
      const [year, month, day, hour, minute, second = 0] = dateValue;
      date = new Date(year, month - 1, day, hour, minute, second);
    } else {
      date = new Date(dateValue);
    }

    if (isNaN(date.getTime())) return "NA";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear());

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${dd}-${mm}-${yy}, ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div className="header_container">
      <ToastNotification
        userId={currentUserId}
        onNotificationReceived={handleNotificationReceived}
      />
      <div className={`top__nav ${collapsed ? " collapsed" : null}`}>
        <div className="top__nav-wrapper">
          <div className="top-menu">
            {collapsed && (
              <img
                src={IResponse_Logo}
                alt="IResponse Logo"
                className="ml-4"
                style={{ height: "3.0em", width: "auto", marginLeft: "16px", marginTop: "10px" }}
              />
            )}
          </div>

          <div className="center-box">{children}</div>

          {profileRoleName === "Citizen" && (
            <div className="heading-title">Citizen Grievance Portal</div>
          )}

          <div className="top__nav-right">
            {/* Bell Icon with Notification Badge */}
            {profileRoleName === "Citizen" ? (
              /* Citizen: only show grievance bell */
              <div style={{ display: "inline-flex", alignItems: "center", marginRight: "16px" }}>
                <div className="bell-tooltip-wrapper" onClick={() => setShowSopModal(true)}>
                  <div style={{ width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <BellIcon size={22} color="black" strokeWidth={1.8} />
                  </div>
                  {sopNotificationCount > 0 && (
                    <span className="bell-badge">
                      {sopNotificationCount > 99 ? "99+" : sopNotificationCount}
                    </span>
                  )}
                  <span className="bell-tooltip-text">Grievance Alerts</span>
                </div>
              </div>
            ) : (
              ["SEOC", "DEOC", "FIELD OFFICER"].includes((roleName || "").toUpperCase()) && (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "14px", marginRight: "16px" }}>
                  {/* 1. Pre Disaster Alerts */}
                  <div className="bell-tooltip-wrapper" onClick={handleShowNotificationModal}>
                    <span className="bell-ring" style={{marginTop:"0px"}}>
                      <Siren size={27} color="black" />
                    </span>
                    {notificationCount > 0 && (
                      <span className="bell-badge">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </span>
                    )}
                    <span className="bell-tooltip-text">Pre Disaster Alerts</span>
                  </div>

                  {/* 2. SOP & Grievance Alerts */}
                  <div className="bell-tooltip-wrapper" onClick={() => setShowSopModal(true)}>
                    <div style={{ width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", marginTop:"7px" }}>
                      <BellIcon size={22} color="black" strokeWidth={1.8} />
                    </div>
                    {sopNotificationCount > 0 && (
                      <span className="bell-badge">
                        {sopNotificationCount > 99 ? "99+" : sopNotificationCount}
                      </span>
                    )}
                    <span className="bell-tooltip-text">SOP & Grievance Alerts</span>
                  </div>
                </div>
              )
            )}
            <div className="top__nav-right">
              {profileData && (
                <div className="user-details">
                  <span className="user-name">
                    {(keycloak.idTokenParsed && keycloak.idTokenParsed.name)
                      ? keycloak.idTokenParsed.name
                      : "Emergency Officer"}
                  </span>
                  <span className="user-role">{roleName || "Disaster Response Team"}</span>
                </div>
              )}
              <div className="profile cursor-pointer" onClick={() => {
                navigate("/userProfile");
              }}>
                <img src={avtarImg} alt="" onError={(e) => { e.target.src = avatar; }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SOP & Grievance Notifications Modal */}
      <Modal
        show={showSopModal}
        onHide={() => setShowSopModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa" }}>
          <Modal.Title style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <BellIcon size={20} />
            {profileRoleName === "Citizen" ? "Grievance Alerts" : "SOP & Grievance Alerts"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {(() => {
            const GRIEVANCE_TYPES = ["TICKET_ESCALATED", "TICKET_RESOLVED", "TICKET_IN_PROGRESS", "TICKET_CREATED", "COMMENT_ADDED"];
            const grievanceList = sopNotifications.filter(n => GRIEVANCE_TYPES.includes(n.notificationType));
            const sopList = sopNotifications.filter(n => !GRIEVANCE_TYPES.includes(n.notificationType));

            const grievanceUnread = grievanceList.filter(n => !n.isRead).length;
            const sopUnread = sopList.filter(n => !n.isRead).length;

            const getBadge = (type) => {
              switch (type) {
                case "TICKET_ESCALATED":   return { label: "Escalated",        color: "#dc2626" };
                case "TICKET_RESOLVED":    return { label: "Resolved",         color: "#16a34a" };
                case "TICKET_IN_PROGRESS": return { label: "In Progress",      color: "#d97706" };
                case "TICKET_CREATED":     return { label: "New Ticket",       color: "#2563eb" };
                case "COMMENT_ADDED":      return { label: "Comment Added",    color: "#7c3aed" };
                case "SOP_EXECUTION":      return { label: "SOP Execution",    color: "#2b4975" };
                default:                   return { label: "Resource Deployed", color: "#18a3a0" };
              }
            };

            const renderItem = (n, index) => {
              const { label, color } = getBadge(n.notificationType);
              return (
                <div
                  key={n.id || index}
                  onClick={() => handleSopNotificationClick(n)}
                  style={{
                    padding: "14px 20px",
                    borderBottom: "1px solid #e5e7eb",
                    backgroundColor: n.isRead ? "#ffffff" : "#f0f7ff",
                    cursor: "pointer",
                    display: "flex",
                    gap: "12px",
                    alignItems: "flex-start",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f3f4f6"}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = n.isRead ? "#ffffff" : "#f0f7ff"}
                >
                  <div style={{ minWidth: "8px", height: "8px", borderRadius: "50%", backgroundColor: color, marginTop: "6px", flexShrink: 0 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                      <span style={{ fontSize: "11px", fontWeight: "700", color, backgroundColor: `${color}18`, padding: "2px 8px", borderRadius: "10px" }}>
                        {label}
                      </span>
                      <small style={{ color: "#9ca3af", fontSize: "11px" }}>{formatDate(n.createdAt)}</small>
                    </div>
                    <div style={{ fontWeight: "600", fontSize: "13px", color: "#1f2937", marginBottom: "4px" }}>{to12HourText(n.notificationTitle)}</div>
                    <div style={{ fontSize: "12px", color: "#4b5563", lineHeight: "1.5" }}>
                      {to12HourText(n.notificationMessage)?.split('\n').map((line, i, arr) => (
                        <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              );
            };

            const activeList = sopActiveTab === "grievance" ? grievanceList : sopList;

            return (
              <>
                {/* Tab Bar */}
                <div style={{ display: "flex", borderBottom: "2px solid #e5e7eb", backgroundColor: "#f8f9fa" }}>
                  {[
                    { key: "grievance", label: "Grievance Alerts", unread: grievanceUnread, color: "#1e40af" },
                    { key: "sop",       label: "SOP Alerts",       unread: sopUnread,       color: "#2b4975" },
                  ].map(tab => {
                    const isActive = sopActiveTab === tab.key;
                    return (
                      <button
                        key={tab.key}
                        onClick={() => setSopActiveTab(tab.key)}
                        style={{
                          flex: 1,
                          padding: "12px 16px",
                          border: "none",
                          borderBottom: isActive ? `3px solid ${tab.color}` : "3px solid transparent",
                          backgroundColor: "transparent",
                          cursor: "pointer",
                          fontWeight: isActive ? "700" : "500",
                          fontSize: "13px",
                          color: isActive ? tab.color : "#6b7280",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "6px",
                          transition: "all 0.15s",
                        }}
                      >
                        {tab.label}
                        {tab.unread > 0 && (
                          <span style={{
                            fontSize: "10px",
                            backgroundColor: isActive ? tab.color : "#d1d5db",
                            color: isActive ? "#fff" : "#374151",
                            borderRadius: "10px",
                            padding: "1px 7px",
                            fontWeight: "700",
                          }}>
                            {tab.unread}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>

                {/* Tab Content */}
                <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                  {activeList.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 20px", color: "#6b7280" }}>
                      <BellIcon size={40} style={{ opacity: 0.25, marginBottom: "12px" }} />
                      <p style={{ fontSize: "13px" }}>No {sopActiveTab === "grievance" ? "grievance" : "SOP"} alerts at the moment</p>
                    </div>
                  ) : (
                    activeList.map(renderItem)
                  )}
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between", backgroundColor: "#f8f9fa" }}>
          <span style={{ fontSize: "13px", color: "#6b7280" }}>
            {sopActiveTab === "grievance"
              ? `${sopNotifications.filter(n => ["TICKET_ESCALATED","TICKET_RESOLVED","TICKET_IN_PROGRESS","TICKET_CREATED","COMMENT_ADDED"].includes(n.notificationType) && !n.isRead).length} unread`
              : `${sopNotifications.filter(n => !["TICKET_ESCALATED","TICKET_RESOLVED","TICKET_IN_PROGRESS","TICKET_CREATED","COMMENT_ADDED"].includes(n.notificationType) && !n.isRead).length} unread`
            }
          </span>
          <div style={{ display: "flex", gap: "8px" }}>
            {sopNotificationCount > 0 && (
              <Button variant="info" onClick={markAllSopNotificationsRead}
                style={{ backgroundColor: "#1C4E72", borderColor: "#1C4E72", color: "#fff", fontSize: "13px" }}>
                Mark All as Read
              </Button>
            )}
            <Button variant="outline-secondary" onClick={() => setShowSopModal(false)} style={{ fontSize: "13px" }}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Disaster Management Notifications Modal */}
      <Modal
        show={showNotificationModal}
        onHide={handleCloseNotificationModal}
        size="lg"
        centered
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        dialogClassName="d-flex align-items-center justify-content-center"
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa" }}>
          <Modal.Title style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <BellIcon size={20} />
            Disaster Management Alerts
            {loading && (
              <span style={{ fontSize: "14px", color: "#6b7280", marginLeft: "8px" }}>
                Loading...
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && notifications.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#6b7280",
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p style={{ marginTop: "16px" }}>Loading disaster alerts...</p>
            </div>
          ) : error ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#dc2626",
              }}
            >
              <AlertTriangle size={48} style={{ opacity: 0.5, marginBottom: "16px" }} />
              <p>{error}</p>
              <Button
                variant="primary"
                onClick={fetchNotifications}
                style={{ marginTop: "12px" }}
              >
                Retry
              </Button>
            </div>
          ) : notifications.length > 0 ? (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {notifications.map((notification, index) => (
                <div
                  key={notification.id || index}
                  style={{
                    padding: "16px",
                    borderBottom: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    marginBottom: "8px",
                    backgroundColor: notification.isRead
                      ? "#ffffff"
                      : getPriorityBgColor(notification.priority),
                    border: `1px solid ${notification.isRead ? "#e5e7eb" : getPriorityColor(notification.priority)}20`,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => handleNotificationClick(notification)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      notification.isRead ? "#ffffff" : getPriorityBgColor(notification.priority);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                        {notification.icon}
                        {/* Case ID and Priority */}
                        <div
                          style={{
                            fontSize: "12px",
                            color: getPriorityColor(notification.priority),
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          Alert ID : {notification.caseId}
                        </div>
                        {/* <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            color: getPriorityColor(notification.priority),
                            backgroundColor: `${getPriorityColor(notification.priority)}15`,
                            padding: "2px 8px",
                            borderRadius: "12px",
                          }}
                        >
                          {notification.priority}
                        </span> */}
                      </div>

                      {/* Notification Title */}
                      <h6
                        style={{
                          margin: "0 0 6px 0",
                          fontWeight: "600",
                          fontSize: "14px",
                          color: "#1f2937",
                        }}
                      >
                        {notification.notificationTitle}
                      </h6>

                      {/* Disaster Type and Location */}
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                        <span style={{ fontSize: "12px", color: "#6b7280", display: "flex", alignItems: "center", gap: "4px" }}>
                          📍 {notification.location}
                        </span>
                        <span style={{ fontSize: "12px", color: "#6b7280", display: "flex", alignItems: "center", gap: "4px" }}>
                          🏷️ {notification.disasterType}
                        </span>
                      </div>

                      {/* Measured Value Info */}
                      {notification.measuredValue && notification.thresholdValue && (
                        <div style={{
                          fontSize: "12px",
                          color: "#4b5563",
                          marginBottom: "6px",
                          padding: "4px 8px",
                          backgroundColor: "#f3f4f6",
                          borderRadius: "4px",
                          display: "inline-block"
                        }}>
                          📊 Measured: <strong>{notification.measuredValue} {notification.unit}</strong> |
                          Threshold: {notification.thresholdValue} {notification.unit}
                        </div>
                      )}

                      {/* Notification Message */}
                      <p
                        style={{
                          margin: "0 0 8px 0",
                          fontSize: "13px",
                          color: "#4b5563",
                          lineHeight: "1.4",
                        }}
                      >
                        {notification.notificationMessage}
                      </p>

                      {/* Created Date */}
                      {notification.severity !== "Warning" && (
                        <small
                          style={{
                            color: "#9ca3af",
                            fontSize: "11px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          Incident Date and Time : 🕐{formatDate(notification.createdAt)}
                        </small>
                      )}
                    </div>

                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#6b7280",
              }}
            >
              <BellIcon
                style={{
                  fontSize: "48px",
                  opacity: 0.3,
                  marginBottom: "16px",
                  color: "#9ca3af",
                }}
              />
              <p>No disaster alerts at the moment</p>
              <p style={{ fontSize: "12px", color: "#9ca3af" }}>All systems operational</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{ justifyContent: "space-between", padding: "12px 20px", backgroundColor: "#f8f9fa" }}
        >
          <div style={{ fontSize: "14px", color: "#6b7280" }}>
            {notifications.length > 0 && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span>
                  {notifications.filter((n) => !n.isRead).length} active alerts
                </span>
                {/* {notifications.filter(n => !n.isRead).length > 0 && (
                  <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <span style={{ width: "8px", height: "8px", backgroundColor: "#dc2626", borderRadius: "50%" }}></span>
                    {notifications.filter(n => !n.isRead && n.priority === "CRITICAL").length} critical
                  </span>
                )} */}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            {notifications.length > 0 &&
              notifications.some(n => !n.isRead) && (
                <Button
                  variant="info"
                  onClick={handleMarkAllAsRead}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#2563eb",
                    borderColor: "#1d4ed8",
                    color: "#fff",
                    fontWeight: "500",
                  }}
                >
                  <BellIcon size={16} />
                  Mark All as Read
                </Button>
              )}
            <Button
              variant="outline-secondary"
              onClick={handleCloseNotificationModal}
              style={{
                borderColor: "#d1d5db",
                color: "#4b5563",
              }}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Header;